import React from 'react';
import CommonWelcomeAdd from '../../../components/Welcome/CommonWelcomeAdd';
import CommonWelcomeList from '../../../components/Welcome/CommonWelcomeList';

const WelcomeInList = () => {
    return (
        <CommonWelcomeList
            pageName='Pazarlama > Karşılamalar > Antrepo Yükleme'
            isOut={false}
            isIn={true}
        />
    )
}

export default WelcomeInList;